import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
import { accessPermission } from '@m/user/permissions'
// import { IS_CLIENT } from '@m/user/accessTokens'

const PROFILE_PREFIX = 'cabinet:profile'
const p = (name: string) => PROFILE_PREFIX + ':' + name

export const PROFILE_VIEW_NAME = p('view')

const ProfileView = () => import('./views/Profile.vue')

const BASE_MODEL_NAME = 'profile/'

export function createRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  // console.log('createRoutes в cabinet/modules/Profile.router.ts', 'прокидіваем title v meta ProfileView')

  return [
    route(
      '',
      ProfileView,
      PROFILE_VIEW_NAME, //cabinet:profile:view
      {
        meta: {
          title: () => $t('Профільні дані'),
        },
      }),
    
  ]
}

export { BASE_MODEL_NAME }